<template>
  <section class="box training" id="training">
    <com-h1 title="深度培训"></com-h1>
    <div class="container">
      <p class="intro">{{ training.introduce }}</p>
      <div class="info">
        <li><i class="time"></i>{{ dateTraining }}</li>
        <li><i class="location"></i>{{ training.address || info.address.name }}</li>
      </div>
      <div class="columns courses">
        <div class="column is-half" v-for="(training, index) in trainings" :key="index">
          <div class="course">
            <h1>
              <router-link :to="'/training/' + training.id">
                <span>{{training.title}}</span>
                <!-- <span class="more"><a href="#">查看更多 >></a></span> -->
              </router-link>
            </h1>
            <p v-html="training.intro"></p>
            <div class="columns teachers">
              <div class="column is-half" v-for="(sid, idx) in training.speakerIds" :key="idx" v-if="speakers[sid]">
                <div class="teacher">
                  <router-link class="img" :to="'/training/' + training.id"><img :src="speakers[sid].avatar"></router-link>
                  <div class="">
                    <h1>{{speakers[sid].name}}</h1>
                    <h2>{{speakers[sid].company}}</h2>
                    <h2 class="position">{{speakers[sid].position}}</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="column">
          <div class="course">
            <h1><span>大数据实时计算</span><span class="more"><a href="#">查看更多 >></a></span></h1>
            <p>提高计算的时效性，更快的从数据中挖掘出信息和知识就意味着能够获取更大的价值。在实时计算领域，Apache Storm、Samza、Spark Streaming、Kafka Stream、Flink 等开源流式计算引擎层出不穷，呈现百家争鸣之势。本次培训中，我们将以典型的实时处理框架为例，分享相关背景、架构设计与应用。</p>
            <div class="columns is-half teachers">
              <div class="column">
                <div class="teacher">
                  <router-link class="img" to="/training/1"><img src="./guosijie.jpg"></router-link>
                  <div class="">
                    <h1>郭斯杰</h1>
                    <h2>Streamlio 的联合创始人</h2>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="teacher">
                  <router-link class="img" to="/training/1"><img src="./huojia.jpg"></router-link>
                  <div class="">
                    <h1>翟佳</h1>
                    <h2>Streamlio 核心创始成员</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="box-button">
        <router-link to="/training"><c-button>了解详情</c-button></router-link>
      </div>
      <!-- <p class="applytip">购买大会和培训套票，可享更多优惠</p> -->
    </div>
  </section>
</template>

<script>
import ComH1 from 'gkConUI/com-h1'
import CButton from 'gkConUI/com-button'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  components: {
    ComH1,
    CButton
  },
  data () {
    return {
    }
  },
  props: ['trainings'],
  created () {},
  computed: {
    ...mapState(['info']),
    dateTraining () {
      if (!this.$store.state.info.beginTimeTraining) return '时间：待定'
      let beginTime = moment(this.$store.state.info.beginTimeTraining).utcOffset('+08:00')
      let endTime = moment(this.$store.state.info.endTimeTraining).utcOffset('+08:00')
      return `时间：${beginTime.format('YYYY.M.D')}-${endTime.format('D')}`
    },
    speakers () {
      return this.$store.state.speakers
    },
    training () {
      return this.$store.state.training || {}
    }
  }
}
</script>

<style lang="sass" scoped>

.training
  padding: 34px 0 50px 0
  text-align: center
  background-image: url('./assets/bg.jpg')
  background-color: #fcfcfc
  background-size: cover
  background-repeat: no-repeat
  background-position: center bottom
  .intro
    text-align: center
    width: 80%
    margin: 0px auto 20px auto
    font-size: 18px
    color: #353535
    line-height: 1.5
    +mobile
      font-size: 14px
      width: 100%
      text-align: justify
  .info
    color: #353535
    margin: 5px 0 40px 0
    display: flex
    justify-content: center
    font-size: 18px
    +mobile
      flex-direction: column
      align-items: center
      font-size: 12px
      margin: 5px 0 25px 0
    li
      list-style: none
      display: flex
      align-items: center
      margin: 0 18px
      +mobile
        // margin: 0 10px
        margin: 2px 0
      i
        display: inline-flex
        width: 1em
        height: 1em
        background-size: contain
        margin-right: 0.3em
        &.time
          background-image: url('./assets/didian-02.svg')
        &.location
          background-image: url('./assets/didian-01.svg')
  .courses
    margin-bottom: 20px
    +tablet
      margin-bottom: 40px
      flex-wrap: wrap

  .courses .course
    background-color: #fff
    padding: 45px 35px
    box-shadow: 0 0 20px 0 rgb(211,220,229)
    +mobile
      padding: 45px 23px 10px 23px
    > h1
      color: var(--primary-color)
      display: flex
      justify-content: space-between
      align-items: flex-end
      font-size: 20px
      padding-bottom: 15px
      border-bottom: 2px solid rgb(233,236,240)
      a
        color: var(--primary-color)
    > p
      height: 140px
      overflow: hidden
      margin-top: 18px
      font-size: 14px
      color: #353535
      line-height: 2
      text-align: justify
      +mobile
        height: auto
    .teachers
      margin-top: 10px
      flex-wrap: wrap
      +mobile
        margin-left: -0.3rem
        margin-right: -0.3rem
        .column
          padding: 0.3rem
    .teacher
      text-align: left
      display: flex
      align-items: center
      .img
        flex-shrink: 0
      img
        width: 80px
        height: 80px
        border: 6px solid #f5f5f5
        border-radius: 80px
        margin-right: 12px
      h1
        font-size: 18px
        color: #353535
      h2
        font-size: 12px
        color: #888
        margin-top: 10px
        &.position
          margin-top: 0
  .applytip
    font-size: 18px
    color: #888
    margin-top: 30px
    +mobile
      margin-top: 20px
      font-size: 14px
</style>
